import React, { useState } from "react";
import axios from "axios";
import "./PaginaInicio.css";
import "./HomeworkPage.css";
import "./ZoomPage.css";
import Cabecera from "../Others/Cabecera";
import PiePagina from "../Others/PiePagina";
import BotonBarraInferior from "../Others/BotonBarraInferior";
import BarraSuperior from "../Others/BarraSuperior";
import BarraInferior from "../Others/BarraInferior";
import { useData } from "./DataContext";
import { getLinks } from "./constants";

const barra_inferior = (
  <BarraInferior
    contenido={
      <>
        <BotonBarraInferior
          imagenSrc={require("../Assets/tablon.png")}
          texto="Foro de Discusión"
          redireccion="pagina-tablon"
        />
        <BotonBarraInferior
          imagenSrc={require("../Assets/contenido.png")}
          texto="Contenido"
          redireccion="pagina-content"
        />
        <BotonBarraInferior
          imagenSrc={require("../Assets/tareas.png")}
          texto="Ejercicios"
          redireccion="pagina-tareas"
        />
        <BotonBarraInferior
          imagenSrc={require("../Assets/tareas.png")}
          texto="Evaluación Diagnostica"
          redireccion="pagina-evaluacion"
        />
        <BotonBarraInferior
          imagenSrc={require("../Assets/tareas.png")}
          texto="Evaluación Final"
          redireccion="pagina-evaluacionfi"
        />
        <BotonBarraInferior
          imagenSrc={require("../Assets/zoom.png")}
          texto="Zoom"
          redireccion="pagina-zoom"
        />
      </>
    }
  />
);

const obtenerLinks = (responseData) => {
  if (Array.isArray(responseData)) {
    return responseData;
  }

  if (Array.isArray(responseData?.data)) {
    return responseData.data;
  }

  if (Array.isArray(responseData?.links)) {
    return responseData.links;
  }

  return [];
};

const obtenerTextoUrl = (url) => {
  if (!url) {
    return "Enlace no disponible";
  }

  try {
    const urlNormalizada = new URL(url);
    return `${urlNormalizada.hostname}${urlNormalizada.pathname === "/" ? "" : urlNormalizada.pathname}`;
  } catch {
    return url;
  }
};

const ZoomPage = () => {
  const { data } = useData();
  const [links, setLinks] = useState([]);
  const [showLinks, setShowLinks] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");

  const barra_superior = (
    <BarraSuperior
      texto_cabecera=""
      menu_materias=""
      menu_mensajes=""
      menu_alertas=""
      menu_actualizaciones=""
      redireccion="admin-home"
      profile_redireccion=" "
    />
  );

  const fetchLinks = async () => {
    if (!data?.matricula) {
      setLinks([]);
      setError(
        "No fue posible identificar tu matrícula para consultar las reuniones.",
      );
      return;
    }

    setCargando(true);
    setError("");

    try {
      const response = await axios.get(getLinks, {
        params: { matricula_alumno: data.matricula },
      });
      setLinks(obtenerLinks(response.data));
    } catch (error) {
      console.error("Error al obtener los links de Zoom:", error);
      setLinks([]);
      setError("No se pudieron cargar las reuniones. Inténtalo nuevamente.");
    } finally {
      setCargando(false);
    }
  };

  const handleFetchLinks = async () => {
    if (showLinks) {
      setShowLinks(false);
      return;
    }

    setShowLinks(true);
    await fetchLinks();
  };

  return (
    <div className="contenedor-pagina">
      <Cabecera
        contenidosuperior={barra_superior}
        contenidoInferior={barra_inferior}
      />
      <main className="student-zoom-page">
        <section className="student-zoom-panel">
          <div className="student-zoom-header">
            <div>
              <span className="student-zoom-eyebrow">Clases en línea</span>
              <h1>Links de Zoom</h1>
              <p>
                Consulta las reuniones disponibles para las clases en las que
                estás inscrito.
              </p>
            </div>

            <button
              className="student-zoom-toggle"
              type="button"
              onClick={handleFetchLinks}
              disabled={cargando}
            >
              {cargando
                ? "Cargando..."
                : showLinks
                  ? "Ocultar reuniones"
                  : "Ver reuniones"}
            </button>
          </div>

          {showLinks && cargando && (
            <div className="student-zoom-state" role="status">
              <span className="student-zoom-spinner" aria-hidden="true" />
              <strong>Cargando reuniones...</strong>
              <p>Estamos consultando los links disponibles para tus clases.</p>
            </div>
          )}

          {showLinks && !cargando && error && (
            <div
              className="student-zoom-state student-zoom-state-error"
              role="alert"
            >
              <span className="student-zoom-state-icon" aria-hidden="true">
                !
              </span>
              <strong>No pudimos cargar las reuniones</strong>
              <p>{error}</p>
              <button type="button" onClick={fetchLinks}>
                Intentar nuevamente
              </button>
            </div>
          )}

          {showLinks && !cargando && !error && links.length === 0 && (
            <div className="student-zoom-state">
              <span
                className="student-zoom-state-icon student-zoom-state-icon-empty"
                aria-hidden="true"
              >
                0
              </span>
              <strong>No hay reuniones disponibles</strong>
              <p>
                Cuando se publique un link de Zoom para tus clases, aparecerá
                aquí.
              </p>
            </div>
          )}

          {showLinks && !cargando && !error && links.length > 0 && (
            <>
              <div className="student-zoom-summary">
                {links.length}{" "}
                {links.length === 1
                  ? "reunión disponible"
                  : "reuniones disponibles"}
              </div>
              <div className="student-zoom-grid">
                {links.map((link, index) => (
                  <article
                    className="student-zoom-card"
                    key={link.id_url || `${link.matricula_clase}-${index}`}
                  >
                    <div className="student-zoom-card-top">
                      <span className="student-zoom-camera" aria-hidden="true">
                        Z
                      </span>
                      <div>
                        <h2>{link.nombre_clase || "Clase sin nombre"}</h2>
                        <span className="student-zoom-matricula">
                          {link.matricula_clase || "Sin matrícula"}
                        </span>
                      </div>
                      <span className="student-zoom-status">Disponible</span>
                    </div>

                    <div className="student-zoom-details">
                      <div>
                        <span>Fecha</span>
                        <strong>{link.fecha || "Sin fecha"}</strong>
                      </div>
                      <div>
                        <span>Hora</span>
                        <strong>{link.hora || "Sin hora"}</strong>
                      </div>
                    </div>

                    <div className="student-zoom-address">
                      <span>Enlace de reunión</span>
                      <strong title={link.url}>
                        {obtenerTextoUrl(link.url)}
                      </strong>
                    </div>

                    <a
                      className={`student-zoom-open${link.url ? "" : " student-zoom-open-disabled"}`}
                      href={link.url || undefined}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-disabled={!link.url}
                    >
                      Entrar a la reunión
                    </a>
                  </article>
                ))}
              </div>
            </>
          )}
        </section>
      </main>
      <PiePagina imagenSrc={require("../Assets/piepagina.jpg")} />
      <footer>Grupo Derecho & Progreso &copy; 2024</footer>
    </div>
  );
};

export default ZoomPage;
